import { sizeMap } from "../components/_NavItemStacked";

const liveAnimated = (size) => ({
  color: "highlight-accent",
  size: {
    lg: 24,
    md: 18,
    sm: 16,
    xs: 14,
  }[size],
  elementTiming: "featured_nav",

});
const uiBoost = (size) => ({
  color: "highlight-five",
  size: sizeMap[size],
  elementTiming: `featured_nav`
});

const uiLaunch = (size) => ({ size: "8px", color: "fg-moderate" });

export const iconPresets = {
  icon_ui_live_animated: liveAnimated,
  ui_live_animated: liveAnimated,
  icon_ui_boost: uiBoost,
  ui_boost: uiBoost,
  icon_ui_launch: uiLaunch,
  ui_launch: uiLaunch,
};
